// ABOUTME: Signs the user out of blab-auth and sends the browser to hosted sign-in
// ABOUTME: Pending stays set once started, because the page navigates away

import type { BrowserAuth } from '@boundarylab/auth/browser';
import { useState } from 'react';
import { auth as defaultAuth } from '../lib/auth-client';

export function useSignOut(auth: BrowserAuth = defaultAuth) {
  const [signingOut, setSigningOut] = useState(false);

  async function signOut() {
    setSigningOut(true);
    await auth.signOut();
    auth.redirectToLogin(window.location.origin);
  }

  return { signOut, signingOut };
}
